/* eslint-disable no-undef */

import React, { Fragment } from 'react';
import {
  Dimensions,
  Image,
  Platform,
  StatusBar,
  View,
  Text
} from 'react-native';
import GoogleTagManager from '../../GoogleTags/GoogleTagManager';
// import {
//   createUTM,
//   getPaymentDetails,
//   SAVINGS
// } from '../../network/request/apirequests';
// import styles from '../../Products/SavingsAccount/errorpage/styles/style';
import {
  getAllUrlParams,
  getGAPathName,
  getMeasure,
  getResponsiveStyle,
  productNames,
  renameKeys
} from '../../utils/appUtils';
import { redirections } from '../../utils/redirectionUtils';
import Loader from './../loader';
import { Base64 } from '../../utils/encrypt';
import { AppConsumer } from '../../AppContext';

// const ErrorPage = ({ measure }) => {
//   return (
//     <View
//       style={[
//         styles.EPmainView,
//         {
//           left: 0,
//           right: 0,
//           top: 0,
//           bottom: 0,
//           position: Platform.OS === 'web' ? 'fixed' : 'absolute',
//         },
//         styles[getResponsiveStyle('EPmainView', measure)],
//       ]}
//     >
//       <Text>Error!!!</Text>
//       {/* <Image
//         style={[styles.EPImage, styles[getResponsiveStyle('EPImage', measure)]]}
//         resizeMode='contain'
//         source={require('../../assets/images/oops.png')}
//       /> */}
//     </View>
//   );
// };

// const getProducts = () => {
//   let product = false;
//   let path = '';
//   let root = '';

//   if (window.location.pathname.split('/').length > 2) {
//     productNames().map(item => {
//       if (
//         window.location.pathname.includes(item.product) &&
//         !window.location.pathname.includes('individual')
//       ) {
//         product = true;
//         path = item.path;
//         root = item.root;
//       }
//     });
//   } else {
//     let isRoot = false;
//     productNames().map(item => {
//       if (window.location.pathname === item.root) {
//         isRoot = true;
//         product = true;
//         path = item.path;
//         root = item.root;
//       }
//     });
//     if (!isRoot) {
//       let products = [{ product: '/', path: '/', root: '/' }];
//       products.map(item => {
//         if (
//           window.location.pathname.includes(item.product) &&
//           !window.location.pathname.includes('individual')
//         ) {
//           product = true;
//           path = item.path;
//           root = item.root;
//         }
//       });
//     }
//   }

//   return { product, path, root };
// };

const hocComponent = Component => {
  return class extends React.Component {
    // static contextType = AppConsumer;

    constructor(props) {
      super(props);
      this.state = {
        measure: getMeasure(this.getWidth()),
        utmLoader: false
      };

      this.additionalEvent = {};
      this.update = false;
    }

    componentWillUpdate() {
      // this.vwoInt();
    }

    componentDidMount() {
      if (Platform.OS === 'web') {
        if (this.props.navigation) {
          this.logMe('new_props----->', this.props.navigation.state.params);
        }
      }

      if (Platform.OS === 'web') {
        let flow = sessionStorage.getItem('flow');
        if (flow) {
          if (!this.props.navigation.state.params) {
            this.props.navigation.state.params = {};
            this.props.navigation.state.params.flow = JSON.parse(flow);
            this.props.navigation.setParams(this.props.navigation.state.params);
            sessionStorage.removeItem('flow');
          }
        }

        // if (
        //   window.location.pathname.includes('product') &&
        //   !window.location.pathname.includes('product-items')
        // ) {
        //   this.createUTMs();
        // }

        if (window.location.search && window.location.pathname === '/') {
          let payload = getAllUrlParams(window.location.href);
          sessionStorage.setItem('query_params', JSON.stringify(payload));
          // this.props.navigation.navigate('HomePage');
        }

        if (
          sessionStorage.getItem('payment_gateway') &&
          Base64.atob(
            Base64.atob(sessionStorage.getItem('payment_gateway'))
          ) === 'api_not_called' &&
          window.location.search
        ) {
          this.setState({ utmLoader: true });
          if (window.location.pathname.includes('transactionDetails')) {
            // redirections({
            //   ...this.props,
            //   api: getPaymentDetails,
            //   service: SAVINGS,
            //   page: 'transactionDetails'
            // });
          } else if (window.location.pathname.includes('errorpage')) {
            redirections({
              ...this.props,
              page: 'errorpage'
            });
          }
        }
      }
    }
    // vwoInt() {
    //   let isAutoloan = window.location.pathname.includes('auto-loan');

    //   let checkProd = !window.location.pathname.includes('nri-account')
    //     ? this.props.navigation.state.params
    //       ? this.props.navigation.state.params.name
    //         ? this.props.navigation.state.params.name.trim().toLowerCase()
    //         : sessionStorage.getItem('product_name')
    //         ? sessionStorage.getItem('product_name').toLowerCase()
    //         : ''
    //       : 'insta save account'
    //     : '';

    //   if (
    //     checkProd === 'insta save account' ||
    //     checkProd === 'insta save fd account' ||
    //     checkProd === 'insta save salary account' ||
    //     isAutoloan
    //   ) {
    //     let path = window.location.pathname.split('/');
    //     if (path.length <= 3) {
    //       let prodName = this.props.navigation.state.params
    //         ? this.props.navigation.state.params.name
    //           ? this.props.navigation.state.params.name.trim().toLowerCase()
    //           : sessionStorage.getItem('product_name').toLowerCase()
    //         : 'Homepage';
    //       let prod = 'Homepage';
    //       if (prodName === 'insta save account') {
    //         prod = 'InstaSaving';
    //       } else if (prodName === 'insta save fd account') {
    //         prod = 'InstaSavingFD';
    //       } else if (prodName === 'insta save salary account') {
    //         prod = 'InstaSalary';
    //       } else if (prodName === 'insta save the one savings account') {
    //         prod = 'InstaTheOne';
    //       } else if (prodName === 'insta save gold privilege savings account') {
    //         prod = 'InstaGoldPrivilege';
    //       } else if (prodName === 'insta save companion account') {
    //         prod = 'InstaSaveCompanion';
    //       }

    //       if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('savings-account')
    //       ) {
    //         prod = 'InstaSaving';
    //       } else if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('salary-account')
    //       ) {
    //         prod = 'InstaSalary';
    //       } else if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('insta-current-account')
    //       ) {
    //         prod = 'InstaCurrent';
    //       } else if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('nri-account')
    //       ) {
    //         prod = 'InstaNRI';
    //       } else if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('credit-card')
    //       ) {
    //         prod = 'InstaCreditCard';
    //       } else if (
    //         prod == 'Homepage' &&
    //         window.location.pathname.includes('personal-loan')
    //       ) {
    //         prod = 'InstaPersonalLoan';
    //       }

    //       if (path.length > 1) {
    //         if (path[2]) path = path[2];
    //         else path = path[1];
    //       } else {
    //         path = '';
    //       }
    //       let url = getGAPathName(path);
    //       let iciciUrl = 'SBOnline';
    //       if (isAutoloan) {
    //         prod = 'CarLoan';
    //         iciciUrl = 'Loans';
    //       }
    //       if (
    //         this.additionalEvent.page !==
    //         '/VPV/NLI/' + iciciUrl + '/' + prod + '/' + url
    //       ) {
    //         this.logMe(
    //           'vwo--->',
    //           '/VPV/NLI/' + iciciUrl + '/' + prod + '/' + url,
    //           'path--->' + path
    //         );
    //         this.update = true;
    //         this.additionalEvent = {
    //           event: 'NewVirtualPageview',
    //           page: '/VPV/NLI/' + iciciUrl + '/' + prod + '/' + url,
    //           FedId: '${relnum}'
    //         };
    //       } else {
    //         this.update = false;
    //       }

    //       window.vwoCode.vwo('/VPV/NLI/' + iciciUrl + '/' + prod + '/' + url);
    //     } else {
    //       let prodName = this.props.navigation.state.params
    //         ? this.props.navigation.state.params.name
    //           ? this.props.navigation.state.params.name.trim().toLowerCase()
    //           : sessionStorage.getItem('product_name').toLowerCase()
    //         : 'insta save account';
    //       let prod = 'InstaSaving';
    //       if (prodName === 'insta save account') {
    //         prod = 'InstaSaving';
    //       } else if (prodName === 'insta save fd account') {
    //         prod = 'InstaSavingFD';
    //       } else if (prodName === 'insta save salary account') {
    //         prod = 'InstaSalary';
    //       }

    //       if (path.length > 2) {
    //         path = path[3];
    //       } else {
    //         path = '';
    //       }
    //       let url = getGAPathName(path);
    //       if (
    //         this.additionalEvent.page !==
    //         '/VPV/NLI/SBOnline/' + prod + '/' + url
    //       ) {
    //         this.logMe(
    //           'vwo--->',
    //           '/VPV/NLI/SBOnline/' + prod + '/' + url,
    //           'path--->' + path
    //         );
    //         this.update = true;
    //         this.additionalEvent = {
    //           event: 'NewVirtualPageview',
    //           page: '/VPV/NLI/SBOnline/' + prod + '/' + url,
    //           FedId: '${relnum}'
    //         };
    //       } else {
    //         this.update = false;
    //       }

    //       window.vwoCode.vwo('/VPV/NLI/SBOnline/' + prod + '/' + url);
    //     }
    //   }
    // }

    // createUTMs() {
    //   var windowValues = window.location;
    //   const { makeAPICall } = this.props;
    //   if (windowValues.search) {
    //     let url = windowValues.search.split('=');
    //     if (url[0].includes('utm')) {
    //       this.setState({ utmLoader: true });
    //       let payload = getAllUrlParams(windowValues.href);
    //       payload = renameKeys(payload, 'insta_utm_source', 'utm_source');
    //       payload = renameKeys(payload, 'insta_utm_product', 'utm_product');
    //       sessionStorage.setItem(
    //         'query_params',
    //         JSON.stringify(getAllUrlParams(windowValues.href))
    //       );
    //       makeAPICall(
    //         createUTM([payload.utm_source, payload.utm_product], SAVINGS),
    //         res => {
    //           this.logMe('res---', res);
    //           let product = res.data.product_name;
    //           if (!res.data.body) {
    //             switch (product) {
    //               case 'INSTA SAVE ACCOUNT':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case 'INSTA SAVE FD ACCOUNT':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case 'INSTA SAVE SALARY ACCOUNT':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case 'INSTA SAVE THE ONE':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case 'INSTA SAVE GOLD PRIVILEGE':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case 'INSTA SAVE COMPANION':
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               case [
    //                 `${require('../../Products/SavingsAccount/config').PRODUCTS[
    //                   'G I C'
    //                 ].toUpperCase()}`,
    //               ]:
    //                 this.moveToProduct(product, 'savings');
    //                 break;
    //               default:
    //                 this.props.navigation.navigate('errorpage');
    //             }
    //           } else if (!res.data.product_name) {
    //             this.props.navigation.navigate('errorpage');
    //           }
    //         },
    //         err => { }
    //       );
    //     }
    //   }
    // }

    // moveToProduct(product, flow) {
    //   if (flow === 'savings') {
    //     let ENTRIES1 = require('../../Products/SavingsAccount/config.js')
    //       .ENTRIES_INITIAL;
    //     ENTRIES1.map((item, i) => {
    //       if (product === item.title.toUpperCase()) {
    //         if (!this.props.navigation.state.params) {
    //           this.props.navigation.state.params = {};
    //           this.props.navigation.state.params.flow = true;
    //           this.props.navigation.state.params.name = ENTRIES1[i].title + ' ';
    //           this.props.navigation.state.params.knowmore =
    //             ENTRIES1[i].knowmore;
    //           this.props.navigation.state.params.content = ENTRIES1[i].content;
    //           this.props.navigation.state.params.accType = 'Savings';
    //           this.props.navigation.state.params.newUser = true;
    //           this.props.navigation.state.params.newuser = true;
    //         } else {
    //           this.props.navigation.state.params = {
    //             ...this.props.navigation.state.params,
    //           };
    //         }
    //         this.props.navigation.navigate(
    //           'personalDetails',
    //           this.props.navigation.state.params
    //         );
    //       }
    //     });
    //   }
    // }

    logMe = (tag, ...message) => {
      if (Platform.OS === 'web') {
        if (
          window.location.hostname === 'localhost' ||
          window.location.hostname === 'reacticicidev.niveussolutions.com'
        ) {
          //console.log(tag, ...message);
        }
      } else {
        //console.log(tag, ...message);
      }
    };

    handleLayout = ({ nativeEvent }) => {
      const { width } = nativeEvent.layout;
      this.logMe('width>> ', width);
      const measure = getMeasure(width);
      this.setState(() => ({ measure }));
    };

    getWidth = () => {
      const { width } = Dimensions.get('window');
      return width;
    };

    render() {
      const { measure } = this.state;
      const { isLoading } = this.props;

      const isValidFlow = () => {
        let flow =
          this.props.navigation.state.params &&
          this.props.navigation.state.params.flow === true;
        // if(Platform.OS === 'web'){
        //   if (
        //     !window.location.pathname.includes('track-application') &&
        //     !window.location.pathname.includes('references') &&
        //     // getProducts().product &&
        //     window.location.pathname !== window.location.origin &&
        //     // path !== getProducts().path &&
        //     // path !== getProducts().root
        //   ) {
        //     return flow;
        //   }
        // }

        return true;
      };
      return (
        <Fragment>
          <StatusBar
            backgroundColor={isLoading ? '#000000E6' : '#101d6c'}
            barStyle='light-content'
          />
          <View onLayout={this.handleLayout} />
          <Component
            showToast={this.showToast}
            logme={this.logMe}
            {...this.props}
            context={this.context}
            measure={measure}
          />
          {/* {this.additionalEvent && (
            <GoogleTagManager
              gtmId='GTM-TSZ2GZK'
              additionalEvents={this.additionalEvent}
              update={this.update}
            />
          )} */}
        </Fragment>
      );
    }
  };
};

export { hocComponent };
